<template>
	<div class="m-flow-scroll">
		<div class="m-flow flex-start">
			<div class="flex-column flex-end">
				<div class="flex-column flex-center">
					<div class="branch flex-center" @click="$emit('route', 'm_order_deliver')">
						<i class="tf">&#xe628;</i>
						<p>订单发货</p>
					</div>
					<flow-arrow width="120" height="45" color="#999" :arrow="['dashed 60,40 60,12']"></flow-arrow>
				</div>
				<div class="flex-column flex-end" style="gap: 80px;">
					<div class="flex-center">
						<div class="start flex-center">客户来单</div>
						<flow-arrow width="50" height="60" :arrow="['5,30 38,30']"></flow-arrow>
						<div class="flow flex-column flex-center" @click="$emit('route', 'm_order')">
							<i class="tf">&#xe698;</i>
							<p>创建销售单</p>
						</div>
						<flow-arrow width="50" height="60" :arrow="['5,30 38,30']"></flow-arrow>
						<div class="flow flex-column flex-center" @click="$emit('route', 'm_order')">
							<i class="tf">&#xe69b;</i>
							<p>销售订单</p>
						</div>
					</div>

					<div class="flex-center">
						<div class="start flex-center">计划生产</div>
						<flow-arrow width="50" height="60" :arrow="['5,30 38,30']"></flow-arrow>
						<div class="flow flex-column flex-center" @click="$emit('route', 'm_plan')">
							<i class="tf">&#xe769;</i>
							<p>创建计划单</p>
						</div>
						<flow-arrow width="50" height="60" :arrow="['5,30 38,30']"></flow-arrow>
						<div class="flow flex-column flex-center" @click="$emit('route', 'm_plan')">
							<i class="tf">&#xe74d;</i>
							<p>生产计划</p>
						</div>
					</div>
				</div>
			</div>

			<flow-arrow width="242" height="200" :arrow="[
				'5,30 197,30 197,58',
				'5,170 197,170 197,142',
				'dashed 55,30 55,58',
				'dashed 55,170 55,142'
			]" style="margin-top: 85px;"></flow-arrow>

			<div class="flex-column flex-end" style="margin-left: -232px;">
				<div class="flex flex-end" style="padding-top: 65px;">
					<div class="flex-center">
						<div class="flow mini flex-column flex-center" @click="$emit('route', 'm_assemble')">
							<i class="tf">&#xe708;</i>
							<p>装配工单</p>
						</div>
					</div>
					<flow-arrow width="50" height="60" :arrow="['5,30 38,30']"></flow-arrow>
					<div class="flow mini flex-column flex-center" @click="$emit('route', 'm_work')">
						<i class="tf">&#xe756;</i>
						<p>工单</p>
					</div>
					<flow-arrow width="50" height="60" :arrow="['5,30 38,30']"></flow-arrow>
					<div class="flow mini flex-column flex-center" @click="$emit('route', 'm_task')">
						<i class="tf">&#xe758;</i>
						<p>任务</p>
					</div>
					<flow-arrow width="50" height="60" :arrow="['5,30 38,30']"></flow-arrow>
					<div class="flex-column flex-center" style="margin: 0 -50px;">
						<div class="flex" style="gap: 10px;">
							<div class="branch mini flex-center" @click="$emit('route', 'm_quality_output')">
								<i class="tf">&#xe650;</i>
								<p>报工检</p>
							</div>
							<div class="branch mini flex-center" @click="$emit('route', 'm_quality_work')">
								<i class="tf">&#xe674;</i>
								<p>入库检</p>
							</div>
						</div>
						<flow-arrow width="190" height="50" color="#999" :arrow="[
							'dashed 95,45 95,25 45,25 45,12',
							'dashed 95,25 145,25 145,12'
						]"></flow-arrow>
						<div class="flow mini flex-column flex-center" @click="$emit('route', 'm_output')">
							<i class="tf">&#xe750;</i>
							<p>报工</p>
						</div>
					</div>
					<flow-arrow width="50" height="60" :arrow="['5,30 38,30']"></flow-arrow>
					<div class="flex-column">
						<flow-arrow width="90" height="90" :arrow="['dashed 5,20 45,20 45,78']"></flow-arrow>
						<div class="flow mini flex-column flex-center" @click="$emit('route', 'm_stockin')">
							<i class="tf">&#xe752;</i>
							<p>入库单</p>
						</div>
					</div>
				</div>
				
				<div class="flex-end" style="padding-right: 140px;">
					<div class="flex-column flex-center">
						<flow-arrow width="90" height="45" color="#999" :arrow="['dashed 45,5 45,33']"></flow-arrow>
						<div class="branch mini flex-center" @click="$emit('route', 'm_outsourcing_order')">
							<i class="tf">&#xe69c;</i>
							<p>委外单</p>
						</div>
					</div>
					<flow-arrow width="50" height="40" :arrow="['dashed 5,20 38,20']"></flow-arrow>
					<div class="branch mini flex-center" @click="$emit('route', 'm_outsourcing_settle')">
						<i class="tf">&#xe63c;</i>
						<p>结算单</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import flowArrow from './flow_arrow.vue'

	export default {
		components: {
			flowArrow
		},

		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	@import './flow'
</style>